import React from "react";
import { useDrag } from 'react-dnd';

export default function MainDraggableToken(props) {
	const [, drag] = useDrag({
		item: { type: 'Token', value: props.value, count: props.count },
		collect: monitor => ({
			isDragging: !!monitor.isDragging(),
		}),
		end: (dropResult, monitor) => {
			let droppedItem = monitor.getDropResult();
			if (droppedItem !== null && droppedItem.type !== undefined) {
				if (monitor.didDrop() && dropResult.count >= dropResult.value) {
					props.decreaseStarterKit("tokens", dropResult.value);
				}
			}
		}
	});

	const canDrag = (props.canEdit) ? drag : null
	return (
		<div className="tokenDraggable" ref={canDrag}>
			<div className="Token-container-draggable">
				<div className="Token-value">{ props.value }</div>
				<div className="Token-text">Kredit liability credito</div>
			</div>
		</div>
	);
}

/*<Image src={tokenImg} />*/